import { Table, TableBody, TableCell, TableHead, TableRow, Grid, Box, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { CurrencyField } from '@roc/ui';
import { observer } from 'mobx-react';

const defaultAmount = '$0.00';

const useStyles = makeStyles((theme: Theme) => ({
  table: {
    border: '2px #e0e0e0 solid',
    '& td': {
      height: '40px',
      padding: 0,
      paddingTop: '8px',
      paddingBottom: '8px',
    },
    '& th:first-child, td[rowSpan], $addNewItemRow td': {
      paddingLeft: theme.spacing(2),
      paddingRight: '3px',
    },
    '& table tr:last-child td, & table td[rowSpan]': {
      borderBottom: 'none',
    },
  },
  headerCell: {
    height: '41px',
    fontWeight: 'bold',
    padding: '0 4px 0 0',
    fontFamily: 'Oswald, sans-serif;',
  },
  descriptionCell: {
    paddingLeft: 8,
    paddingRight: 3,
  },
  border: {
    borderBottom: 0,
    height: '20px',
    maxHeight: '20px',
  },
  cell: {
    paddingLeft: 3,
    paddingRight: 3,
  },
  containerScroll: {
    width: '100%',
    overflowX: 'auto',
  },
  tableBig: {
    minWidth: 750,
    tableLayout: 'fixed',
  },
  fullWidthTable: {
    width: '100%',
    tableLayout: 'fixed',
  },
  currencyInput: {
    height: '40px',
    '& input': {
      paddingTop: '10px',
      paddingBottom: '10px',
    },
  },
}));


export const InterestAllocationTable = observer(({ columns, rows }) => {
  const classes = useStyles();

  const isSmallSize = columns.length <= 6;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12} className={classes.containerScroll}>
        <Table className={`${classes.table} ${isSmallSize ? classes.fullWidthTable : classes.tableBig}`}>
          <TableHead>
            <TableRow>
              {columns.map(({ name, ...props }) => (
                <>
                  <TableCell
                    id={`${name}_${columns.findIndex(col => col.name === name)}`}
                    key={name}
                    className={classes.headerCell}
                    style={{
                      width: isSmallSize ? props.width : '150px',
                    }}
                    align={props.align}>
                    {name}
                  </TableCell>
                </>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map(((row, rowIndex) => (
              <TableRow key={row.description}>
                {columns.map(({ mapping }, colindex) => (
                  <TableCell
                    key={`${mapping}-${colindex}`}
                    className={classes.border}
                    align={columns[colindex].align}
                    style={{
                      width: isSmallSize ? columns[colindex].width : '150px',
                    }}>
                    <Box className={mapping === "description" ? classes.descriptionCell : classes.cell} >
                      {mapping === "description" ? (
                        row[mapping as keyof typeof row]
                      ) : (
                        <CurrencyField
                          value={row[mapping as keyof typeof row] ?? 0}
                          variant="outlined"
                          testId="cost"
                          onChange={(name, value) => {
                            row[mapping as keyof typeof row] = value;
                          }}
                          fullWidth
                          disabled={rowIndex === rows?.length - 1}
                          inputClassname={classes.currencyInput}
                          allowNegative
                        />
                      )}
                    </Box>
                  </TableCell>
                )
                )}
              </TableRow>
            )))}
          </TableBody>
        </Table>
      </Grid>
    </Grid >
  );
});
